import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Dphistory from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import { useWebSocket } from "../../Websocket/useWebSocket";

const DpHistoryContainer = () => {
  const navigate = useNavigate();
  const { uId } = useParams();
  const { makeApiRequest } = useApiRequest();
  const { wsData, startWebSocket } = useWebSocket();

  const [loader, setLoader] = useState(false);
  const [unlinkModal, setUnlinkModal] = useState(false);
  const [bpHistory, setBpHistory] = useState([]);
  const [requestsSubmitted, setRequestsSubmitted] = useState(false);
  const [paymentOptionsList, setPaymentOptionsList] = useState([]);
  const [rechargeModal, setRechargeModal] = useState(false);
  const [amount, setAmount] = useState(null);
  const [webSocketFlag, setWebSocketFlag] = useState(false);
  const [rechargeSuccessModal, setRechargeSuccessModal] = useState(false);

  const razorpayMethod =
    localStorage.getItem("default_Recharge_PgName") === "RECHARGE_R_CARD"
      ? "card"
      : localStorage.getItem("default_Recharge_PgName") === "RECHARGE_R_WALLET"
      ? "wallet"
      : "UPI";

  let rechargeOrderId = null;

  // 🔹 Load scripts & initial data
  useEffect(() => {
    fetchDpHistory();
    fetchPaymentOptions();
    //clearPreCart()
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // 🔹 Fetch Payment Options
  const fetchPaymentOptions = (e, index, slot_id, currentCount, operation) => {
     setLoader(true)
   
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const now = new Date();
    const to = now.toISOString().slice(0, 19).replace("T", " ");
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    const from = lastMonth.toISOString().slice(0, 19).replace("T", " ");

 

   

    makeApiRequest({
        url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/payment/option?machineId=0&balancePgArr=PAYTM%7CWALLET_LOYALTY%7CWALLET`,
      method: "GET",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
 
      handleSuccess: (res) => handleResponsetPaymentOptions(res),
      handleError: handleErrorPaymentOptions,
    });
  };

const handleResponsetPaymentOptions=(res)=>{
     setLoader(false)
  //console.log("payment option",res.data.data)
  setPaymentOptionsList(res.data.data)

}
const handleErrorPaymentOptions=()=>{
setLoader(false)
}
const fetchDpHistory = () => {
  setLoader(true);

  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");

  // ==========================
  //   CURRENT TIME (UTC)
  // ==========================
  const now = new Date();
  const to = now.toISOString().slice(0, 19).replace("T", " ");

  // ==========================
  //   1 MONTH BEFORE (UTC)
  // ==========================
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  const from = oneMonthAgo.toISOString().slice(0, 19).replace("T", " ");

  // ==========================
  //   API CALL
  // ==========================
  makeApiRequest({
    url: "https://api-prod.daalchini.co.in/consumer/api/v1/user/order/history?sortBy=DESC",
    method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
      "x-app-platform": "web",
      "x-app-version": "v1.0.1",
      "x-device-id": deviceId,
      "Content-Type": "application/json",
    },
    data: {
      from,
      to,
      pgId: 9,
      uid: deviceId,  // same as curl
    },
    handleSuccess: (res) => handleResponsetDpHistory(res),
    handleError: handleErrorDpHistory,
  });
};


const handleResponsetDpHistory=(res)=>{
  //console.log("data",res.data.data.payload)
  setBpHistory(res.data.data.payload)

}

const handleErrorDpHistory=()=>{
setLoader(false)
}



  // 🔹 Add Amount to Cart before Recharge

 const AddIntoCart = (e) => {
if(!amount){
    toast.error("Please Enter Amount");
    return 
}


     setLoader(true)
   
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const now = new Date();
    const to = now.toISOString().slice(0, 19).replace("T", " ");
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    const from = lastMonth.toISOString().slice(0, 19).replace("T", " ");

 

   

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=-1`,
     method: "PATCH",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data: [{ slotId: 100, count: amount }],
      handleSuccess: (res) => handleResponsetAddIntoCart(res),
      handleError: handleErrorAddIntoCart,
    });
  };

  const handleResponsetAddIntoCart=(res)=>{
    createOrderRecharge()

  }

  const handleErrorAddIntoCart=(error)=>{
       toast.error(error.response?.data?.status?.message || "Failed to add to cart");
  }





  // 🔹 Create Recharge Order



 const createOrderRecharge = (e) => {
     setLoader(true)
   
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");

 

   

    makeApiRequest({
        url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/-1/order`,
     method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{ type: "recharge" },
      handleSuccess: (res) => handleResponsetcreateOrderRecharge(res),
      handleError: handleErrorcreateOrderRecharge,
    });
  };

const handleResponsetcreateOrderRecharge=(res)=>{
 rechargeOrderId = res?.data?.data?.orderId;
       initiatePaymentApi(rechargeOrderId);
        //handleStartWebSocket(rechargeOrderId);

      openRazorpay();

}


const handleErrorcreateOrderRecharge=()=>{

}



  // 🔹 Initiate Payment API


 const initiatePaymentApi = (orderId) => {
  
     setLoader(true)
   
        const UserJWTAuth = localStorage.getItem("UserJWTAuth");


 

   

    makeApiRequest({
        url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/${orderId}/payment`,
     method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
          "x-app-platform": "web",
          "x-app-version": "v1.0.1",
          "x-device-id": localStorage.getItem("uuid"),
        },
        data:{ pgId: 2 },
      handleSuccess: (res) => handleResponsetinitiatePaymentApi(res,orderId),
      handleError:(error)=> handleErrorcreateinitiatePaymentApi(error),
    });
  };

  const handleResponsetinitiatePaymentApi=(res,orderId)=>{
//console.log("orderId",orderId)
    //listenWebSocket(orderId);
    //handleStartWebSocket(orderId)
    connectWebSocket(orderId)

  }

  const handleErrorcreateinitiatePaymentApi=(error)=>{
          toast.error(error.response?.data?.status?.message || "Payment initiation failed");

  }

   
const connectWebSocket = (orderId) => {
  console.log("Connecting WebSocket for order:", orderId);
  //if (!orderId) return;

  //console.log("🔌 Connecting WebSocket for order:", orderId);
  const ws = new WebSocket(
    `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`

 
  );

  ws.onopen = () => {
    //console.log("✅ WebSocket connected:", orderId);
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
    console.log("📩 WebSocket Message:", data);

      if (data.success) {
        toast.success("Recharge successful!", { autoClose: 1000 });
        setRechargeSuccessModal(true)
        setRechargeModal(false)
        setLoader(false);
        //fetchTagHistory();
      //fetchTagDetails();
        ws.close();
      }
    } catch (err) {
      console.error("❌ Error parsing WebSocket message:", err);
    }
  };

  ws.onerror = (error) => {
    console.error("❌ WebSocket error:", error);
  };

  ws.onclose = () => {
    console.log("🔴 WebSocket closed");
  };

  // Optional: return the instance if you need to close manually
  return ws;
};

  // -----------------------------
  const clearPreCart = () => {
    const token = localStorage.getItem("UserJWTAuth");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid"),
      },
      handleSuccess: () => {},
      handleError: showError,
    });
  };

  const showError = (error) => {
    console.error(error);
    setLoader(false);
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      navigate("/login");
    } else {
      toast.error(
        error?.response?.data?.status?.message || "Something went wrong",
        { position: "top-right", autoClose: 1000 }
      );
    }
  };


  // 🔹 Razorpay Payment
const openRazorpay = () => {
       const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  const payAmount = amount * 100;

      const options = {
        key: "rzp_live_ZVpG4pXQKTLFCS",
        amount: `${payAmount}`,
        description:`order=${rechargeOrderId}`,
        //image: logo,
        handler: function (response) {
        
         // console.log("razorpay response",response,response)
          let userKey;
          userKey = UserJWTAuth
          handlePaymentSuccess(response,rechargeOrderId);
          
          const payload = {
            header: {
              oauthToken: UserJWTAuth,
              userkey: userKey,
            },
            data: {
              request: {
                orderId: rechargeOrderId,
                //paymentGateway: orderData.paymentGateway,
                paymentId: 9,
                paymentStatus: 9
                  ? "SUCESS"
                  : "FAILED",
              },
              onClose: function() {
               
                //alert('Payment modal closed!');
                
                setLoader(false)
                document.getElementById('razorpay-container').remove();
              },
              
          
             
            },
          };
          
          
    
          
        },
       
        prefill: {
          email: "info@daalchini.co.in",
            contact:
              JSON.parse(localStorage.getItem("userDetails")) &&
              JSON.parse(localStorage.getItem("userDetails")).mobileNo,
          method:razorpayMethod
            
            
        },
        
        theme: {
          color: "#432B2B",
          hide_topbar: false,
        },
        notes: {
          order_id:rechargeOrderId,
        },
        onpaymenterror: function (error) {
          handlePaymentError(error);
        },
        modal: {
          ondismiss: function (error) {
            //console.log("error",error)
            handlePaymentError(error);
          }
        }
      
      };

  const rzp = new window.Razorpay(options);
  setLoader(false);
  rzp.open();
};

const handlePaymentSuccess = (response,rechargeOrderId) => {
  ///console.log("rechargeOrderId", rechargeOrderId);
  fetchDpHistory()
  fetchPaymentOptions()
  connectWebSocket(rechargeOrderId)
 
};

const handlePaymentError = () => {
  setRechargeModal(false);
  setWebSocketFlag(false);
  setLoader(false);
};



  // 🔹 WebSocket Listener
  const listenWebSocket = (orderId) => {
    setLoader(true);
    const ws = new WebSocket(
      `wss://api-prod.daalchini.co.in/consumerbe/status/payment?order_id=${orderId}`
    );

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.success) {
       
        setRechargeSuccessModal(true);
        setWebSocketFlag(false);
        setLoader(false);
      }
    };
  };

  // 🔹 Open Recharge Modal
  const RechargeFun = () => {
    localStorage.setItem("payment_back_route", "/dphistory");
    clearPreCart()
    setRechargeModal(true);
  };

  return (
    <Dphistory
    clearPreCart={clearPreCart}
      bpHistory={bpHistory}
      unlinkModal={unlinkModal}
      setUnlinkModal={setUnlinkModal}
      UnLinkModalfun={() => setUnlinkModal(true)}
      requestsumbitted={requestsSubmitted}
      setRequestsumbitted={setRequestsSubmitted}
      paymentOptionsList={paymentOptionsList}
      rechargeModal={rechargeModal}
      setRechargeModal={setRechargeModal}
      setAmount={setAmount}
      amount={amount}
      AddIntoCart={AddIntoCart}
      RechargeFun={RechargeFun}
      rechargeSuccessModal={rechargeSuccessModal}
      setRechargeSuccessModal={setRechargeSuccessModal}
      loader={loader}
    />
  );
};

export default DpHistoryContainer;
